import { useTranslation } from 'react-i18next';

function Hero() {
  const { t } = useTranslation();
  const stats = t('hero.stats', { returnObjects: true });

  return (
    <section className="hero section">
      <div className="hero-content">
        <div className="eyebrow">{t('hero.eyebrow')}</div>

        <h1>{t('hero.title')}</h1>

        <p className="hero-description">{t('hero.description')}</p>

        <div className="hero-actions">
          <a href="#contact" className="button primary">
            {t('hero.primaryCta')}
          </a>
          <a href="#services" className="button secondary">
            {t('hero.secondaryCta')}
          </a>
        </div>

        <div className="hero-stats" aria-label={t('hero.statsAria')}>
          {stats.map((stat) => (
            <div key={stat.title}>
              <strong>{stat.title}</strong>
              <span>{stat.text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="hero-visual" aria-label={t('hero.visualAria')}>

        <div className="mockup-window">
          <div className="mockup-topbar">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <div className="mockup-content">
            <div className="mockup-card large">
              <div className="mockup-label">{t('hero.mockup.react')}</div>
              <div className="mockup-line wide"></div>
              <div className="mockup-line"></div>
              <div className="mockup-metrics">
                <span>UI</span>
                <span>UX</span>
                <span>SCSS</span>
              </div>
            </div>

            <div className="mockup-grid">
              <div className="mockup-card">
                <div className="mockup-label">{t('hero.mockup.rails')}</div>
                <div className="mockup-line"></div>
              </div>

              <div className="mockup-card accent">
                <div className="mockup-label">{t('hero.mockup.sql')}</div>
                <div className="mockup-line"></div>
              </div>
            </div>

            <div className="mockup-terminal">
              <span>{t('hero.mockup.deploy')}</span>
              <span>{t('hero.mockup.monitor')}</span>
              <span>{t('hero.mockup.update')}</span>
              <span>{t('hero.mockup.maintain')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
